import { CSSProperties, useCallback } from 'react';
import cx from 'classnames';

import { getLineWidth, Step } from './Steps.constants';
import styles from './Steps.module.sass';

interface StepsProps {
  currentStep: number;
  steps: Step[];
  className?: string;
  onClickStep: (step: number) => void;
}

const Steps = ({
  currentStep,
  steps,
  className,
  onClickStep,
}: StepsProps): JSX.Element => {
  const handleOnClickStep = useCallback(
    (step: number) => {
      if (step >= currentStep) return;

      onClickStep(step);
    },
    [onClickStep, currentStep],
  );

  const classes = cx(styles.steps, className);

  return (
    <div
      className={classes}
      style={
        { '--steps-offset': `${100 / steps.length / 2}%` } as CSSProperties
      }
    >
      <div className={styles.line}>
        <div
          className={styles.lineInner}
          style={{
            width: getLineWidth(currentStep, steps),
          }}
        />
      </div>

      {steps.map((step, index) => {
        const stepIndex = index + 1;

        const stepClasses = cx(styles.step, {
          [styles['is-active']]: currentStep >= stepIndex,
          [styles['is-clickable']]: currentStep > stepIndex,
        });

        return (
          <button
            key={step.slug}
            type="button"
            className={stepClasses}
            onClick={() => handleOnClickStep(stepIndex)}
          >
            <span className={styles.number}>
              <span className={styles.value}>{stepIndex}</span>
            </span>
            <span className={styles.label}>{step.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default Steps;
